/* Anemoia — "Saved to favourites" toast.
   Feedback on EVERY save, on every heart (grid card, PDP button, cart-drawer favourite).

   Why a separate file rather than an edit to anemoia-wishlist.js: the wishlist already owns the
   first-save email-capture drawer, the heart fill and the header count. The only thing missing was
   a per-save confirmation — so this bolts on without touching that 19KB file.

   How it stays correct: rather than racing the wishlist's own click handlers (per-button on the
   grid/PDP, delegated on document for the cart drawer — registration order isn't guaranteed), we
   read the committed state AFTER the click settles via window.AnemoiaWishlist.has(handle). That's
   the single source of truth (localStorage), so the message is never stale. Guarded → no-op if the
   wishlist API isn't present. */
(function () {
  'use strict';

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.6-9.3-9C1.2 8 2.6 5 5.6 5c2 0 3.2 1.3 3.9 2.4l.5.8.5-.8C11.2 6.3 12.4 5 14.4 5c3 0 4.4 3 2.9 6-2.3 4.4-9.3 9-9.3 9z"/></svg>';
  var VISIBLE_MS = 2000;
  var el = null, timer = null;

  function css() {
    if (document.getElementById('awl-toast-css')) return;
    var s = document.createElement('style');
    s.id = 'awl-toast-css';
    s.textContent = [
      '.awl-toast{position:fixed;left:50%;bottom:26px;transform:translate(-50%,14px);z-index:2147483002;',
      'display:flex;align-items:center;gap:8px;background:#1f1713;color:#f5f2ee;',
      'font-family:var(--font-body-family),-apple-system,Helvetica,Arial,sans-serif;',
      'font-size:12.5px;letter-spacing:.06em;padding:11px 18px;border-radius:100px;',
      'box-shadow:0 10px 30px rgba(20,14,10,.28);opacity:0;pointer-events:none;',
      'transition:opacity .3s ease,transform .3s ease;}',
      '.awl-toast.in{opacity:1;transform:translate(-50%,0);}',
      '.awl-toast svg{width:13px;height:13px;flex:none;}',
      '.awl-toast svg path{fill:#e7cfa0;stroke:#e7cfa0;stroke-width:1.4;}',
      '.awl-toast[data-off="1"] svg path{fill:none;stroke:rgba(245,242,238,.6);}',
      /* On phones the bottom belongs to the sticky add-to-cart bar and the chat launcher. */
      '@media (max-width:749px){.awl-toast{bottom:auto;top:16px;}.awl-toast.in{transform:translate(-50%,0);}}',
      '@media (prefers-reduced-motion:reduce){.awl-toast{transition:none;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function show(msg, saved) {
    css();
    if (!el) {
      el = document.createElement('div');
      el.className = 'awl-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.setAttribute('data-off', saved ? '0' : '1');
    el.innerHTML = HEART + '<span>' + msg + '</span>';
    // Reveal next frame, with a timer fallback in case rAF is throttled.
    requestAnimationFrame(function () { if (el) el.classList.add('in'); });
    setTimeout(function () { if (el) el.classList.add('in'); }, 30);
    clearTimeout(timer);
    timer = setTimeout(function () { if (el) el.classList.remove('in'); }, VISIBLE_MS);
  }

  // CAPTURE phase (the `true`), not bubble — this is load-bearing. The wishlist's grid-card heart
  // handler calls e.stopPropagation(), so a bubble-phase listener on document never fires for it.
  // Capture runs on the way down, before the target's own handler, so we always see the click; the
  // setTimeout(0) below then reads the state after that handler has committed.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.awl-heart[data-awl-h], .awl-pdp[data-awl-h], .awl-fav[data-awl-h]');
    if (!b) return;
    var handle = b.getAttribute('data-awl-h');
    if (!handle) return;
    setTimeout(function () {
      var WL = window.AnemoiaWishlist;
      if (!WL || !WL.has) return;
      var saved = WL.has(handle);
      show(saved ? 'Saved to favourites' : 'Removed from favourites', saved);
    }, 0);
  }, true);
})();
